import { styled } from 'styled-components';

export const Text = styled.p`
  margin-bottom: var(--spacing-small);
`;
